export default "__VITE_ASSET__CDAudT2x__"